import React from 'react';
import { useSelector } from 'react-redux';
import Header from '../../../../../../../components/Stake/header';
import OMUniIcon from '../../../../../../../assets/images/OM icon.png';
import { formatToken } from '../../../../../../../helpers/token-helper';
import Confirm from '../../../../../../../components/Stake/frame/confirm';

const WithdrawConfirm = () => {
  const { unstakedBalance } = useSelector((state) => state.ZENWBTCUNIstake.stake);
  const withdrawBalance = `${formatToken(unstakedBalance, 10)} OM`;

  return (
    <>
      <Header icon={OMUniIcon} title='OM-Withdrawal' />
      <Confirm title='You Are Withdrawing:' token={withdrawBalance} />
    </>
  );
};

export default WithdrawConfirm;
